import { Middleware } from '@reduxjs/toolkit';
import { RootState } from '../../store';
import { selectFilterChangeFunction } from '../filterChangeActionSlice';
import { selectFilters } from '../filtersSlice';

export const filterChangeMiddleware: Middleware = ( store ) => ( next ) => ( action: any ) => {
  const prevState = store.getState() as RootState;
  const prevFilters = selectFilters( prevState );

  const result = next( action );

  if (
    action.type === 'filters/setFilters' ||
    action.type === 'filters/addFilter' ||
    action.type === 'filters/removeFilter' ||
    action.type === 'filters/clearFilters'
  ) {
    const state = store.getState() as RootState;
    const filterChangeFunction = selectFilterChangeFunction( state );
    const currentFilters = selectFilters( state );

    // Only call onFilterChange if filters actually changed (prevents echo loops)
    if ( filterChangeFunction ) {
      if ( JSON.stringify( prevFilters ) !== JSON.stringify( currentFilters )) {
        filterChangeFunction( currentFilters );
      }
    }
  }

  return result;
};
